import React from 'react';
import DropDown from '../../../components/shared/dropdown';
import { useTextResources } from '../../../language';
import { TaxIdentityFeatureEnum } from '../../../components/shared/constants';

const TaxIdentityTypeDropDown = ({ ...rest }) => {
    const text = useTextResources();
    const types = [
        {
            text: text('TaxAuthority'),
            Id: TaxIdentityFeatureEnum.TaxAuthority
        },
        {
            text: text('DigitalInvoice'),
            Id: TaxIdentityFeatureEnum.DigitalInvoice
        }
    ];
    return <DropDown textField="text" valueField="Id" selectFirst  {...rest} data={types} />
}

export default TaxIdentityTypeDropDown;